import url from '../config/url';
import HttpService from './HttpService';

export default class PasswordReset {
  constructor() {
    this.http = new HttpService();
    this.url = `${url.resetPasswordUrl}`;
  }

	async postResetPassword(request) {
		const { data } = await this.http.post({
			url: `${this.url}`,
			data: request,
		});
		return data;
	}

}
